import { connect } from 'react-redux'
import {
  selectLeftNavAgentsForMailboxId,
  selectLeftNavMailboxById,
} from 'selectors/left_nav'
import {
  selectCurrentUserIsAdmin,
  selectCurrentUserIsOwner,
} from 'ducks/currentUser/selectors'
import { selectAgentCount } from 'selectors/agents/base'
import View from './view'

const selectFactory = (_, initialOwnProps) => {
  const { mailboxId } = initialOwnProps

  return state => {
    return {
      agents: selectLeftNavAgentsForMailboxId(state, mailboxId),
      activeAgentCount: selectAgentCount(state),
      mailbox: selectLeftNavMailboxById(state, mailboxId),
      isAdmin: selectCurrentUserIsAdmin(state),
      isOwner: selectCurrentUserIsOwner(state),
    }
  }
}

export default connect(selectFactory)(View)
